import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import HeroSection from "./sections/HeroSection";
import ServicesGrid from "./sections/ServicesGrid";
import Machineryrepairtrust from "./sections/Machineryrepairtrust";
import CallToAction from "./sections/CallToAction";
import Visitorcounter from "./sections/Visitorcounter";
import ServicesGridCopy from "./sections/ServicesGridCopy";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <HeroSection />
      <ServicesGrid />
      <ServicesGridCopy />
      <Machineryrepairtrust />
      <CallToAction />
      <Visitorcounter />
      <Footer />
    </div>;
}